import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37680852"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row py-4 d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 py-4" }, [
  /*#__PURE__*/_createElementVNode("h2", {
    class: "m-0 p-0",
    style: {"color":"var(--cor_texto_1)"}
  }, "Lista de Lojas")
], -1))
const _hoisted_3 = { class: "col-lg-7 d-flex align-items-center justify-content-end gap-5 flex-wrap" }
const _hoisted_4 = {
  id: "stores-input-filter",
  class: "w-100 w-md-auto"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  style: {"color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end gap-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Adicionar", -1))
const _hoisted_11 = {
  id: "box-table-stores",
  class: "background_1 card"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "gap-4 d-flex py-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20.5 14.6321V6.66064L11.6711 11.2412C11.6513 11.2514 11.6313 11.2611 11.6112 11.2701V19.9996L19.8866 15.5987C20.2668 15.3966 20.5 15.0291 20.5 14.6321ZM9.10027 11.2416L0.5 6.77966V14.6325C0.5 15.0295 0.733188 15.397 1.11337 15.5991L9.38883 20V11.3464C9.28999 11.3243 9.19288 11.2896 9.10027 11.2416Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.770142 4.61364C0.875191 4.49443 1.00778 4.39369 1.16237 4.3197L9.91231 0.131854C10.2796 -0.0439512 10.7202 -0.0439512 11.0876 0.131854L19.8375 4.3197C19.9567 4.37673 20.0628 4.44967 20.1532 4.5347L10.5599 9.51182C10.4968 9.54455 10.4386 9.58199 10.3856 9.62337C10.3326 9.58199 10.2745 9.54455 10.2114 9.51182L0.770142 4.61364Z",
    fill: "white"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_18 = { class: "d-flex py-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dropdown btn btn-sm" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-ellipsis-v",
    "aria-hidden": "true",
    style: {"color":"var(--cor_btn_1)","margin":"0","padding":"0"}
  })
], -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-4" }, "Recuperar", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.3",
    d: "M50.0005 70H20.0005V45H10.0005V85C10.0005 87.7656 12.2349 90 15.0005 90H55.0005C57.7662 90 60.0005 87.7656 60.0005 85V45H50.0005V70ZM99.1568 32.2187L85.8287 12.2187C84.8912 10.8281 83.3287 10 81.6568 10H18.3443C16.6724 10 15.1099 10.8281 14.188 12.2187L0.859921 32.2187C-1.35883 35.5469 1.01617 40 5.01617 40H95.0005C98.9849 40 101.36 35.5469 99.1568 32.2187ZM80.0005 87.5C80.0005 88.875 81.1255 90 82.5005 90H87.5005C88.8755 90 90.0005 88.875 90.0005 87.5V45H80.0005V87.5Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M99.1563 32.2187L85.8282 12.2187C84.8907 10.8281 83.3282 10 81.6563 10H18.3438C16.6719 10 15.1094 10.8281 14.1876 12.2187L0.859433 32.2187C-1.35932 35.5469 1.01568 40 5.01568 40H95.0001C98.9844 40 101.359 35.5469 99.1563 32.2187Z",
    fill: "white"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampDropdownHeader = _resolveComponent("CampDropdownHeader")!
  const _component_CampDropdownItem = _resolveComponent("CampDropdownItem")!
  const _component_CampDropdown = _resolveComponent("CampDropdown")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_SkeletonComponent = _resolveComponent("SkeletonComponent")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_CampModalDelRegister = _resolveComponent("CampModalDelRegister")!
  const _component_CampModalRecoverRegister = _resolveComponent("CampModalRecoverRegister")!
  const _component_modalRelationStore = _resolveComponent("modalRelationStore")!
  const _component_modalRelationCompetitor = _resolveComponent("modalRelationCompetitor")!
  const _component_modalRelationCompany = _resolveComponent("modalRelationCompany")!
  const _component_modalRelationProduct = _resolveComponent("modalRelationProduct")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.keywordSearch,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywordSearch) = $event)),
            placeholder: "Busque por alguma Loja",
            type: "text"
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_switch, {
            id: "form-training-post-active",
            modelValue: _ctx.activeStatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeStatus) = $event)),
            style: {"--el-switch-on-color":"var(--el-color-primary)"}
          }, null, 8, ["modelValue"]),
          (_ctx.activeStatus)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Ativos"))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "Inativos"))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: `/loja/cadastrar`,
            class: "btn btn_background_1 d-md-flex align-items-center justify-content-center"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_CampTable, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createVNode(_component_CampTableTh, null, {
                default: _withCtx(() => [
                  _createTextVNode("CNPJ")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, null, {
                default: _withCtx(() => [
                  _createTextVNode("Nome Fantasia")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, null, {
                default: _withCtx(() => [
                  _createTextVNode("Cidade")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("UF")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, null, {
                default: _withCtx(() => [
                  _createTextVNode("Responsável")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, null, {
                default: _withCtx(() => [
                  _createTextVNode("E-mail")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, null, {
                default: _withCtx(() => [
                  _createTextVNode("Consultor")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("Data de cadastro")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("Telefone")
                ]),
                _: 1
              }),
              _createVNode(_component_CampTableTh, {
                class: "text-center",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ações")
                ]),
                _: 1
              })
            ])
          ]),
          (!_ctx.isLoading && _ctx.printStores?.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printStores, (store) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.campHandleCNPJ(store.cnpj, "formatted") || store.cnpj), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(store.fantasy_name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${store.city ? store.city : '-'}`), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${typeof store.uf == "string" && store.uf.toLocaleUpperCase() != "UF" ? store.uf : '-'}`), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(store.responsible), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(store.email), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(store.consultant_name || '-'), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.moment(store.created_at).format('DD/MM/YYYY')), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.campHandleBrPhoneNumber(store.telephone, "formatted") || store.telephone), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "d-flex" }, {
                      default: _withCtx(() => [
                        (!store.deleted_at)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("button", {
                                  class: "btn btn-sm background_btn_1",
                                  onClick: () => _ctx.redirectToStoreProducts(store.id!)
                                }, _hoisted_16, 8, _hoisted_14),
                                _createVNode(_component_router_link, {
                                  to: `/loja/atualizar/${store.id}`,
                                  class: "btn btn-sm background_btn_1_opct"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_CampDropdown, null, {
                                  button: _withCtx(() => [
                                    _hoisted_19
                                  ]),
                                  header: _withCtx(() => [
                                    _createVNode(_component_CampDropdownHeader, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Mais opções ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  list: _withCtx(() => [
                                    _createVNode(_component_CampDropdownItem, {
                                      onClick: ($event: any) => (_ctx.funcDetailRelationData(store))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Adicionar usuário ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_CampDropdownItem, {
                                      onClick: ($event: any) => (_ctx.funcDetailRelationDataCompetitor(store))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Adicionar vendedor ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    (_ctx.authStore.isAdmUser)
                                      ? (_openBlock(), _createBlock(_component_CampDropdownItem, {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.funcDetailRelationDataCompany(store))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Adicionar companhia ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_CampDropdownItem, {
                                      onClick: ($event: any) => (_ctx.handleModalDelRegister(store))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Excluir loja ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.handleModalRecoverRegister(store)),
                              class: "btn btn-sm background_btn_1_opct w-100 d-flex align-items-center py-3 px-12 mt-2"
                            }, _hoisted_23, 8, _hoisted_20))
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SkeletonComponent, {
            key: 0,
            rows: 5
          }))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isLoading && !_ctx.printStores?.length)
      ? (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
          key: 0,
          id: "stores-icon-empty-list-feedback"
        }, {
          icon: _withCtx(() => [
            _hoisted_24
          ]),
          message: _withCtx(() => [
            _createTextVNode("Não há nada para mostrar")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_CampModalDelRegister, {
      toggle: _ctx.toggleModalDelRegister,
      name: _ctx.itemDel?.fantasy_name || '',
      handleButtonClick: () => _ctx.handleConfirmItemDel()
    }, null, 8, ["toggle", "name", "handleButtonClick"]),
    _createVNode(_component_CampModalRecoverRegister, {
      toggle: _ctx.toggleModalRecoverRegister,
      name: _ctx.itemDel?.fantasy_name || '',
      handleButtonClick: () =>_ctx.fetchDeletedStores()
    }, null, 8, ["toggle", "name", "handleButtonClick"]),
    _createVNode(_component_modalRelationStore, {
      "relation-data": (_ctx.relationData as any),
      "is-change-props": (_ctx.relationProps.store as any)
    }, null, 8, ["relation-data", "is-change-props"]),
    _createVNode(_component_modalRelationCompetitor, {
      "relation-data": (_ctx.relationData as any),
      "is-change-props": (_ctx.relationProps.competitor as any)
    }, null, 8, ["relation-data", "is-change-props"]),
    _createVNode(_component_modalRelationCompany, {
      "relation-data": (_ctx.relationData as any),
      "is-change-props": (_ctx.relationProps.company as any)
    }, null, 8, ["relation-data", "is-change-props"]),
    _createVNode(_component_modalRelationProduct, {
      "relation-data": (_ctx.relationData as any),
      "is-change-props": (_ctx.relationProps.product as any)
    }, null, 8, ["relation-data", "is-change-props"])
  ]))
}